/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otp_ExpiredInputs */

const en_us2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code has expired. Request a new one.`)
};

const pt_br2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código expirou. Peça um novo.`)
};

const es_419_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese código expiró. Pide uno nuevo.`)
};

const pt_pt2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código expirou. Pede um novo.`)
};

const fr_fr2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce code a expiré. Demandes-en un nouveau.`)
};

const de_de2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Code ist abgelaufen. Fordere einen neuen an.`)
};

const it_it2_otp_expired = /** @type {(inputs: Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo codice è scaduto. Richiedine uno nuovo.`)
};

/**
* | output |
* | --- |
* | "That code has expired. Request a new one." |
*
* @param {Otp_ExpiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const otp_expired = /** @type {((inputs?: Otp_ExpiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otp_ExpiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_otp_expired(inputs)
	if (locale === "es-419") return es_419_otp_expired(inputs)
	if (locale === "pt-PT") return pt_pt2_otp_expired(inputs)
	if (locale === "fr-FR") return fr_fr2_otp_expired(inputs)
	if (locale === "de-DE") return de_de2_otp_expired(inputs)
	if (locale === "it-IT") return it_it2_otp_expired(inputs)
	return en_us2_otp_expired(inputs)
});
export { otp_expired as "otp.expired" }